<div class="d-flex justify-content-center align-items-center" style="height: calc(100vh - 100px)">
  <div class="coming-soon-container">
    <h1>Coming Soon!</h1>
    <p>This feature is currently under development. Stay tuned, we are working on it!</p>
    <button class="px-0" onclick="alert('Thank you for your patience!')">Notify Me</button>
  </div>
</div>
